import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'rugby-ball',
  size: 24,
  node: [
    ['path', { d: 'm10 10 4 4', key: '1twawc' }],
    ['path', { d: 'm13 7 4 4', key: '17f0qu' }],
    [
      'path',
      {
        d: 'M15.34 2.138A15 15 0 002.138 15.34c-.357 2.94.004 4.919.805 5.717.798.8 2.778 1.162 5.718.805A15 15 0 0021.862 8.661c.357-2.94-.004-4.92-.805-5.718-.798-.8-2.778-1.162-5.717-.805',
        key: '7bv9ob',
      },
    ],
    ['path', { d: 'M17 7 7 17', key: '15tmo1' }],
    ['path', { d: 'm7 13 4 4', key: 'ir98si' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name RugbyBall
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTAgMTAgNCA0IiAvPgogIDxwYXRoIGQ9Im0xMyA3IDQgNCIgLz4KICA8cGF0aCBkPSJNMTUuMzQgMi4xMzhBMTUgMTUgMCAwMDIuMTM4IDE1LjM0Yy0uMzU3IDIuOTQuMDA0IDQuOTE5LjgwNSA1LjcxNy43OTguOCAyLjc3OCAxLjE2MiA1LjcxOC44MDVBMTUgMTUgMCAwMDIxLjg2MiA4LjY2MWMuMzU3LTIuOTQtLjAwNC00LjkyLS44MDUtNS43MTgtLjc5OC0uOC0yLjc3OC0xLjE2Mi01LjcxNy0uODA1IiAvPgogIDxwYXRoIGQ9Ik0xNyA3IDcgMTciIC8+CiAgPHBhdGggZD0ibTcgMTMgNCA0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/rugby-ball
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RugbyBall = createLucideIcon(__iconData);

export default RugbyBall;
